import { cn } from '@tebuto/lib/utils'
import { getIn, useFormikContext } from 'formik'

import type { JSX } from 'react'
import { useFieldErrorVisible } from './useFieldErrorVisible'

interface ErrorMessageProps {
    name: string
    className?: string
}

export default function FormErrorMessage({ name, className = '' }: ErrorMessageProps): JSX.Element | null {
    const { errors } = useFormikContext()
    const showError = useFieldErrorVisible(name)
    const error = getIn(errors, name)

    if (!showError || error === undefined || error === '') {
        return null
    }

    const message = Array.isArray(error) ? error.join(', ') : String(error)

    return (
        <div className="mt-1 flex min-h-5 items-start">
            <span className={cn('text-xxs text-red-500 font-medium block min-w-0', className)}>{message}</span>
        </div>
    )
}
